import * as Yup from 'yup';

// Validação para informações básicas
export const basicInfoValidationSchema = Yup.object().shape({
  name: Yup.string()
    .required('Nome é obrigatório')
    .min(3, 'Nome deve ter no mínimo 3 caracteres')
    .max(255, 'Nome deve ter no máximo 255 caracteres'),
  
  email: Yup.string()
    .email('E-mail inválido')
    .required('E-mail é obrigatório')
    .max(255, 'E-mail deve ter no máximo 255 caracteres'),
  
  documentNumber: Yup.string()
    .required('CPF é obrigatório')
    .matches(
      /^\d{3}\.\d{3}\.\d{3}-\d{2}$|^\d{11}$/,
      'CPF deve estar no formato XXX.XXX.XXX-XX ou ter 11 dígitos'
    ),
  
  status: Yup.string()
    .required('Status é obrigatório'),
});

// Validação para perfil e permissões
export const profileValidationSchema = Yup.object().shape({
  role: Yup.string()
    .required('Tipo de usuário é obrigatório'),
});

// Validação para informações pessoais
export const personalInfoValidationSchema = Yup.object().shape({
  birth_date: Yup.date()
    .max(new Date(), 'Data de nascimento não pode ser no futuro')
    .min(new Date('1900-01-01'), 'Data de nascimento inválida')
    .optional(),
  
  gender_flag: Yup.string()
    .optional(),
  
  phoneNumber: Yup.string()
    .matches(
      /^\(\d{2}\) \d{4,5}-\d{4}$/,
      'Telefone deve estar no formato (XX) XXXXX-XXXX'
    )
    .optional(),
  
  cnh_number: Yup.string()
    .matches(/^\d{11}$/, 'CNH deve ter 11 dígitos')
    .optional(),
  
  cnh_expiration_date: Yup.date()
    .min(new Date(), 'Data de validade da CNH deve ser futura')
    .when('cnh_number', {
      is: (cnh_number: string) => cnh_number && cnh_number.length > 0,
      then: (schema) => schema.required('Data de validade da CNH é obrigatória'),
      otherwise: (schema) => schema.optional(),
    }),
  
 
  
  unit: Yup.string()
    .optional(),
  
  section_name: Yup.string()
    .optional(),
  
  description: Yup.string()
    .max(500, 'Descrição deve ter no máximo 500 caracteres')
    .optional(),
});

// Validação para senha (apenas na criação ou alteração)
export const passwordValidationSchema = Yup.object().shape({
  password: Yup.string()
    .min(6, 'Senha deve ter no mínimo 6 caracteres')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número'
    ),
  
  confirmPassword: Yup.string()
    .oneOf([Yup.ref('password')], 'Confirmação de senha não confere')
    .when('password', {
      is: (password: string) => password && password.length > 0,
      then: (schema) => schema.required('Confirmação de senha é obrigatória'),
      otherwise: (schema) => schema.optional(),
    }),
});

// Schema completo para validação de usuário
export const userValidationSchema = Yup.object().shape({
  ...basicInfoValidationSchema.fields,
  ...profileValidationSchema.fields,
  ...personalInfoValidationSchema.fields,
  ...passwordValidationSchema.fields,
  

});

// Schema para criação (senha obrigatória)
export const createUserValidationSchema = userValidationSchema.shape({
  password: Yup.string()
    .min(6, 'Senha deve ter no mínimo 6 caracteres')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número'
    )
    .required('Senha é obrigatória'),
});

// Schema para edição (senha opcional)
export const updateUserValidationSchema = userValidationSchema.shape({
  password: Yup.string()
    .min(6, 'Senha deve ter no mínimo 6 caracteres')
    .matches(
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)/,
      'Senha deve conter pelo menos uma letra minúscula, uma maiúscula e um número'
    )
    .optional(),
});